import { render, staticRenderFns } from "./ChartLoader.vue?vue&type=template&id=10e42739&scoped=true&"
import script from "./ChartLoader.vue?vue&type=script&lang=js&"
export * from "./ChartLoader.vue?vue&type=script&lang=js&"
import style0 from "./ChartLoader.vue?vue&type=style&index=0&id=10e42739&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e42739",
  null
  
)

export default component.exports